export default "__VITE_ASSET__DNwPL4Fs__"